import SynchronizationIcon from './component'

export default SynchronizationIcon
